import { V1WorkspaceType } from '@/generated/hooks/agora/models/v1WorkspaceType';

/**
 * The finance workspace is auto-created by the backend when an organization is
 * created (alongside the user's own workspace). Agora (>= v1.67.0) tags it with
 * a `workspace_type` of `WORKSPACE_TYPE_FINANCE`, which is the authoritative
 * discriminant — a user can freely rename a workspace, so the title is not.
 *
 * The CFO-glance landing page is scoped to this workspace only — every other
 * workspace keeps its normal landing (Automations).
 */
export function isFinanceWorkspaceType(
  workspaceType?: V1WorkspaceType | null,
): boolean {
  return workspaceType === V1WorkspaceType.WORKSPACE_TYPE_FINANCE;
}
